<template>
    <div>
        <div class="loader" v-show="loading"></div>
        <div v-show="!loading">
            <kendo-datasource ref="datasource"
                              :transport="transportSettings"
                              :schema-model-fields="schemaModelFields"
                              :schema-model-id="'id'"
                              :schema-total="'total'"
                              :schema-data="'data'"
                              :page-size="defaultGridRows"
                              :server-paging="true"
                              :server-sorting="true"
                              :server-filtering="true"
                              :change="onChange"></kendo-datasource>

            <kendo-grid ref="certificatesGrid"
                        :data-source-ref="'datasource'"
                        :editable="gridOptions.editable"
                        :filterable="gridOptions.filterable"
                        :pageable="gridOptions.pageable"
                        :reorderable="gridOptions.reorderable"
                        :resizable="gridOptions.resizable"
                        :groupable="gridOptions.groupable"
                        :allow-copy="gridOptions.allowCopy"
                        :column-menu="gridOptions.columnMenu"
                        :sortable-mode="gridOptions.sortable.mode"
                        :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                        :sortable-show-indexes="gridOptions.sortable.showIndexes"
                        :selectable="gridOptions.selectable"
                        :scrollable="gridOptions.scrollable"
                        :data-bound="onDatabound">
                <kendo-grid-column :field="'id'" :title="'Id'"></kendo-grid-column>
                <kendo-grid-column :field="'number'" :title="$t('certificates.number')"></kendo-grid-column>
                <kendo-grid-column :field="'personName'" :title="$t('certificates.personName')"></kendo-grid-column>
                <kendo-grid-column :field="'eventId'" :title="$t('certificates.eventId')" :hidden="true"></kendo-grid-column>
                <kendo-grid-column :field="'eventName'" :title="$t('certificates.eventName')"></kendo-grid-column>
                <kendo-grid-column :field="'eventCode'" :title="$t('certificates.eventCode')"></kendo-grid-column>
                <kendo-grid-column :field="'evaluation'" :title="$t('certificates.evaluation')" :hidden="true"></kendo-grid-column>
                <kendo-grid-column :field="'createdByUsername'" :title="$t('certificates.createdBy')"></kendo-grid-column>
                <kendo-grid-column :field="'createdOn'" :title="$t('certificates.createdOn')" :format="'{0:dd.MM.yyyy HH:mm}'"></kendo-grid-column>
                <kendo-grid-column :template="btnsTemplate"
                                   field="btnsColumn"
                                   :title="' '"
                                   :width="100">
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BtnsTemplate from '@/components/grid/StandardBtnsTemplate';
    import { mapGetters } from 'vuex'

    export default {
        name: 'UserCertificatesList',
        props: {
            userId: {
                type: String,
                default: null
            },
            personId: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                defaultGridRows: this.$store.getters.defaultGridRows,
                searchQuery: '',
                schemaModelFields: {
                    id: { field: 'id', type: 'number', nullable: false, editable: false },
                    number: { field: 'number', type: 'string', nullable: true, editable: false },
                    personId: { field: 'personId', type: 'string', nullable: true, editable: false },
                    personName: { field: 'personName', type: 'string', nullable: true, editable: false },
                    eventId: { field: 'eventId', type: 'string', nullable: true, editable: false },
                    eventName: { field: 'eventName', type: 'string', nullable: true, editable: false },
                    eventCode: { field: 'eventCode', type: 'string', nullable: true, editable: false },
                    validFrom: { field: 'validFrom', type: 'date', nullable: true, editable: false },
                    validTo: { field: 'validTo', type: 'date', nullable: true, editable: false },
                    evaluation: { field: 'evaluation', type: 'string', nullable: true, editable: false },
                    attachmentId: { field: 'attachmentId', type: 'string', nullable: true, editable: false },
                    createdOn: { field: 'createdOn', type: 'date', nullable: true, editable: false },
                    createdBy: { field: 'createdBy', type: 'string', nullable: true, editable: false },
                    createdByUsername: { field: 'createdByUsername', type: 'string', nullable: true, editable: false },
                    deletedOn: { field: 'deletedOn', type: 'date', nullable: true, editable: false },
                    deletedBy: { field: 'deletedBy', type: 'string', nullable: true, editable: false },
                    deletedByUsername: { field: 'deletedByUsername', type: 'string', nullable: true, editable: false },
                    docTypeCode: { field: 'docTypeCode', type: 'string', nullable: true, editable: false },
                    hash: { field: 'hash', type: 'string', nullable: true, editable: false },
                    title: { field: 'title', type: 'string', nullable: true, editable: false }
                },
                loading: false
            };
        },
        methods: {
            onDatabound(e) {
                var items = e.sender.items();
                items.each(function (idx, item) {
                    let dataItem = e.sender.dataItem(item);
                    if (dataItem.statusId === 2) {
                        $(item).addClass('left-border-danger');
                    } else if (dataItem.statusId === 4 || dataItem.statusId === 7) {
                        $(item).addClass('left-border-success');
                    }
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) };
                } else {
                    return kendo.stringify(options);
                }
            },
            onChange(data) {
                // parse date field in the grid data
                data.items.forEach(item => {
                    item.validFrom = item.validFrom ? new Date(item.validFrom) : '';
                    item.validTo = item.validTo ? new Date(item.validTo) : '';
                    item.createdOn = item.createdOn ? new Date(item.createdOn) : '';
                });
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            boolCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' +
                    (dataItem.archived ? 'badge-success' : 'badge-secondary') +
                    '">' +
                    kendo.htmlEncode(dataItem.archived ? this.$t('yes') : this.$t('no')) +
                    '</span></div>';

                return templateHtml;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        // parentComponent: this.$refs.createdByMeGrid,
                        btns: [
                            {
                                name: 'download',
                                text: '',
                                tooltip: this.$t('certificates.download'),
                                class: 'btn btn-info',
                                icon: 'far fa-file-pdf',
                                show: true,
                                clickHandler: this.downloadPdf
                            }
                        ]
                    }
                };
            },
            downloadPdf(e) {
                const downloadUri = this.$store.getters.baseUrl + `/api/file/download/?id=${e.attachmentId}&type=${e.docTypeCode}&hash=${e.hash}`;
                this.loading = true;
                this.$http.get(downloadUri, { responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data]);
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', e.title); // or any other extension
                        document.body.appendChild(link);
                        link.click();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(err => {
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        })
                    })
                    .then(() => { this.loading = false; });
            },
            refresh() {
                this.$refs['certificatesGrid'].kendoWidget().dataSource.read();
            }
        },
        computed: {
            ...mapGetters(['gridOptions']),
            token: function () {
                return this.$store.getters.authToken;
            },
            transportSettings: function () {
                let urlSuffix = this.userId ? `User/${this.userId}` : `Person/${this.personId}`;
                const url = this.$store.getters.baseUrl + '/api/certificates/' + urlSuffix;
                return {
                    read: {
                        url,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                };
            }
        }
    };
</script>

<style>
</style>
